require('./accueil-interface-2.scss');

import MultiplexActions from '../../../../actions/multiplex.actions';
import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import DateUtil from '../../../../utils/date.util';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import includes from 'lodash/includes';

export default class AccueilInterface2Component {
  constructor() {
    this.controller = AccueilInterface2Controller;
    this.template = require('./accueil-interface-2.html');
  }
}

// @ngInject
class AccueilInterface2Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    // Valeurs par défaut
    this.dateMax = new Date().toString();
    this.data = {multiplex: []};
    this.adresse = {};
    this.datePerturbationIsvalid = true;
    this.multiplexCode = {};
    this.muxExclus = ['R15', 'ROM1', 'ROML', 'ROM2'];
    this.muxExclusAntenniste = ['ROM1', 'ROML', 'ROM2'];
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ACCUEIL_INTERFACE_2));
    this.$ngRedux.dispatch(MultiplexActions.loadData());

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          multiplexFailure: state.multiplex.failure,
          fetching: state.demande.fetching || state.multiplex.fetching,
          data: this.prepareAfterGet(state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.asMutable({deep: true}) : this.data),
          multiplex: state.multiplex.data ? state.multiplex.data.data : state.multiplex.data,
          multiplexAll: state.multiplex.data ? state.multiplex.data.data : state.multiplex.data,
          typePersonne: state.demande.data.typePersonne,
          adresse: this.data.adresse
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  onComplementAdresseChange(complementAdresse) {
    this.data.complementAdresse = complementAdresse;
  }
  onAdresseChange(adresse) {
    this.data.adresse = adresse;
  }
  onDatePerturbationChange() {
    this.datePerturbationIsvalid = DateUtil.validate(this.data.datePerturbation);
  }
  prepareAfterGet(data) {
    const res = cloneDeep(data);
    if (res.datePerturbation) {
      res.datePerturbation = DateUtil.dateToMask(res.datePerturbation);
    }
    return res;
  }
  prepareBeforeSend(data) {
    const res = cloneDeep(data);
    if (res.datePerturbation) {
      res.datePerturbation = DateUtil.dateFromMask(res.datePerturbation);
    }
    // On passe les multiplex pour les traitements à réaliser pour passer à l'étape suivante
    //on exclue les multiplex de domtom
    this.multiplex = filter(this.multiplex, m=> !includes(this.typePersonne === 'PRO' ? this.muxExclusAntenniste : this.muxExclus, m.code));
    res.multiplex = this.multiplex;
    res.multiplexAll = this.multiplexAll;
    return res;
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface2({}, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface2(this.prepareBeforeSend(this.data)));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/accueil-interface-2/accueil-interface-2.component.js